"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioLanguageSchema = void 0;
exports.AudioLanguageSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/audio-language.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "AudioLanguage",
    "description": "Representing the language used in the audio stream",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:audio-language"
            ]
        },
        "languageCode": {
            "type": "string",
            "description": "The language of the audio stream, represented in ISO639-1 code notation. For example, 'en' for English, 'de' for German, etc."
        }
    },
    "required": [
        "languageCode",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaW8tbGFuZ3VhZ2Uuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9hdWRpby1sYW5ndWFnZS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxtQkFBbUIsR0FBRztJQUNqQyxLQUFLLEVBQUUsdUVBQXVFO0lBQzlFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGVBQWU7SUFDeEIsYUFBYSxFQUFFLG9EQUFvRDtJQUNuRSxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwyQkFBMkI7YUFDNUI7U0FDRjtRQUNELGNBQWMsRUFBRTtZQUNkLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLGFBQWEsRUFBRSwrSEFBK0g7U0FDL0k7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLGNBQWM7UUFDZCxNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=